// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__1Vxq0","errorLogs":"EditorFooter_errorLogs__1PlMM"};